import { useEffect, useState } from 'react'
import { Alert, Button, Form, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import {
    createNotification,
    deleteNotification,
    listAdminNotifications
} from '../actions/notificationActions'
import {
    NOTIFICATION_CREATE_CLEAR,
    NOTIFICATION_DELETE_CLEAR,
    NOTIFICATION_TYPES
} from '../constants/notificationConstant'
import Loader from './Loader'

const initialForm = {
    title: '',
    message: '',
    type: 'general',
    link: '',
    isGlobal: true
}

const formatNotificationDate = value => value
    ? new Intl.DateTimeFormat('ar-SA', {
        dateStyle: 'medium',
        timeStyle: 'short'
    }).format(new Date(value))
    : '-'

const getTypeLabel = value => {
    const type = NOTIFICATION_TYPES.find(item => item.value === value)
    return type ? type.label : value
}

const NotificationAdminPanel = () => {
    const [formData, setFormData] = useState(initialForm)
    const dispatch = useDispatch()
    const { loading, error, message } = useSelector(state => state.newNotification)
    const { loading: loadingList, error: errorList, notifications } = useSelector(state => state.adminNotifications)
    const { loading: loadingDelete, error: errorDelete, message: deleteMessage } = useSelector(state => state.removeNotification)

    const changeHandler = ({ target: { name, value, type, checked } }) => {
        setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }))
    }

    const submitHandler = e => {
        e.preventDefault()
        dispatch(createNotification({ ...formData, isGlobal: true }))
    }

    const deleteHandler = id => {
        const isConfirm = window.confirm('هل تريد حذف هذا الإشعار؟')
        if(isConfirm) dispatch(deleteNotification(id))
    }

    useEffect(() => {
        dispatch(listAdminNotifications())
    }, [dispatch, message, deleteMessage])

    useEffect(() => {
        if(message) setFormData(initialForm)
    }, [message])

    useEffect(() => () => {
        dispatch({ type: NOTIFICATION_CREATE_CLEAR })
        dispatch({ type: NOTIFICATION_DELETE_CLEAR })
    }, [dispatch])

    return (
        <div className='admin-notifications'>
            <Form className='admin-notifications__form' onSubmit={submitHandler}>
                <h3>إرسال إشعار</h3>
                {loading && <Loader />}
                {error && <Alert variant='danger'>{error}</Alert>}
                {message && <Alert variant='success'>{message}</Alert>}
                {errorDelete && <Alert variant='danger'>{errorDelete}</Alert>}
                {deleteMessage && <Alert variant='success'>{deleteMessage}</Alert>}

                <Form.Group>
                    <Form.Label>عنوان الإشعار</Form.Label>
                    <Form.Control
                        name='title'
                        value={formData.title}
                        type='text'
                        placeholder='مثال: تنبيه مهم'
                        required
                        onChange={changeHandler}
                    />
                </Form.Group>

                <Form.Group>
                    <Form.Label>نص الإشعار</Form.Label>
                    <Form.Control
                        as='textarea'
                        rows={3}
                        name='message'
                        value={formData.message}
                        placeholder='اكتب الرسالة المختصرة التي ستظهر للمستخدم'
                        required
                        onChange={changeHandler}
                    />
                </Form.Group>

                <Form.Group>
                    <Form.Label>نوع الإشعار</Form.Label>
                    <Form.Control
                        as='select'
                        name='type'
                        value={formData.type}
                        required
                        onChange={changeHandler}
                    >
                        {NOTIFICATION_TYPES.map(type => (
                            <option key={type.value} value={type.value}>{type.label}</option>
                        ))}
                    </Form.Control>
                </Form.Group>

                <Form.Group>
                    <Form.Label>الرابط داخل التطبيق</Form.Label>
                    <Form.Control
                        name='link'
                        value={formData.link}
                        type='text'
                        placeholder='مثال: /events أو /news/ID'
                        onChange={changeHandler}
                    />
                </Form.Group>

                <Form.Group className='admin-notifications__check'>
                    <Form.Check
                        name='isGlobal'
                        type='checkbox'
                        label='إشعار عام لكل المستخدمين'
                        checked={formData.isGlobal}
                        disabled
                        onChange={changeHandler}
                    />
                </Form.Group>

                <Button variant='primary' type='submit' disabled={loading}>
                    إرسال الإشعار
                </Button>
            </Form>

            <div className='admin-notifications__list'>
                <h3>آخر الإشعارات</h3>
                {loadingList || loadingDelete ? <Loader />
                    : errorList ? <Alert variant='warning'>{errorList}</Alert>
                        : notifications && <div className='users__table'>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>العنوان</th>
                                        <th>النوع</th>
                                        <th>الرابط</th>
                                        <th>التاريخ</th>
                                        <th>حذف</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {notifications.map(notification => (
                                        <tr key={notification._id}>
                                            <td>{notification.title}</td>
                                            <td>{getTypeLabel(notification.type)}</td>
                                            <td>{notification.link || '-'}</td>
                                            <td>{formatNotificationDate(notification.createdAt)}</td>
                                            <td>
                                                <Button variant='danger' onClick={() => deleteHandler(notification._id)}>
                                                    حذف
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>}
            </div>
        </div>
    )
}

export default NotificationAdminPanel
